const UTM_KEY = "dj_codigo_utm";
const SESSION_KEY = "dj_codigo_session";
const LANDING_KEY = "dj_codigo_landing";
const SEEN_KEY = "dj_codigo_seen";
const CAMPAIGN_KEY = "dj_codigo_campaign";

function uuid() {
  return "sess-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getSessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = uuid();
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

// Capture UTM params on load and persist for the session. Also records landing page + new/returning.
export function captureUtm() {
  const params = new URLSearchParams(window.location.search);
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
  const found = {};
  keys.forEach((k) => {
    const v = params.get(k);
    if (v) found[k] = v;
  });
  if (Object.keys(found).length > 0) {
    sessionStorage.setItem(UTM_KEY, JSON.stringify(found));
  }
  if (!sessionStorage.getItem(LANDING_KEY)) {
    sessionStorage.setItem(LANDING_KEY, window.location.pathname);
    sessionStorage.setItem("dj_codigo_returning", localStorage.getItem(SEEN_KEY) ? "1" : "0");
    localStorage.setItem(SEEN_KEY, String(Date.now()));
  }
  return getUtm();
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem(UTM_KEY) || "{}");
  } catch {
    return {};
  }
}

// Campaign pages set a default attribution when the visitor arrived without UTMs.
export function applyCampaignAttribution(campaign) {
  sessionStorage.setItem(CAMPAIGN_KEY, campaign.slug);
  const utm = getUtm();
  if (!utm.utm_campaign) {
    sessionStorage.setItem(UTM_KEY, JSON.stringify({
      ...utm,
      utm_campaign: campaign.utmCampaign || campaign.slug,
      utm_source: utm.utm_source || campaign.utmSource || "campaign_page",
      utm_medium: utm.utm_medium || campaign.utmMedium || "short_link",
    }));
  }
}

export function getCampaignSlug() {
  return sessionStorage.getItem(CAMPAIGN_KEY) || null;
}

export function getLandingPath() {
  return sessionStorage.getItem(LANDING_KEY) || null;
}

export function isReturningVisitor() {
  return sessionStorage.getItem("dj_codigo_returning") === "1";
}

// Append UTM params to a URL (used for share links + admin link builder).
export function withUtm(url, { source, medium = "social", campaign, content }) {
  const u = new URL(url, window.location.origin);
  if (source) u.searchParams.set("utm_source", source);
  if (medium) u.searchParams.set("utm_medium", medium);
  if (campaign) u.searchParams.set("utm_campaign", campaign);
  if (content) u.searchParams.set("utm_content", content);
  return u.toString();
}
